const DEFAULT_GROUP_BOOKING_LABEL = "Class";

const GROUP_BOOKING_LABELS = [DEFAULT_GROUP_BOOKING_LABEL, "Course", "Group", "Workshop"] as const;

type GroupBookingLabel = (typeof GROUP_BOOKING_LABELS)[number];

const isGroupBookingLabel = (value?: string | null): value is GroupBookingLabel => {
    return value != null && GROUP_BOOKING_LABELS.some((label) => label === value);
};

export const getGroupBookingLabel = (groupBookingLabel?: string | null): string => {
    return isGroupBookingLabel(groupBookingLabel) ? groupBookingLabel : DEFAULT_GROUP_BOOKING_LABEL;
};

const getGroupBookingLabelLowerCase = (groupBookingLabel?: string | null): string => {
    return getGroupBookingLabel(groupBookingLabel).toLowerCase();
};

export const getBookGroupBookingLabel = (groupBookingLabel?: string | null): string => {
    return `Book ${getGroupBookingLabel(groupBookingLabel)}`;
};

export const getBookAGroupBookingLabel = (groupBookingLabel?: string | null): string => {
    return `Book a ${getGroupBookingLabel(groupBookingLabel)}`;
};

export const getGroupBookingDescription = (groupBookingLabel?: string | null): string => {
    return `View available time slots and book a ${getGroupBookingLabelLowerCase(groupBookingLabel)}.`;
};

export const getConfirmedGroupBookingLabel = (groupBookingLabel?: string | null): string => {
    return `Your ${getGroupBookingLabelLowerCase(groupBookingLabel)} booking is confirmed`;
};
